import {COUNTRIES, SECTORS} from "../actions/app.actions";

const INITIAL_STATE = {
    countries: [],
    sectors: []
};

const app = (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case COUNTRIES: {
            console.log(action.payload);
            return {
                ...state,
                countries: action.payload
            }
        }

        case SECTORS: {
            console.log(action.payload);
            return {
                ...state,
                sectors: action.payload
            }
        }
        default:
            return state;
    }
}

export default app;
